var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/register.ts
var register = async (swUrl) => {
  try {
    await navigator.serviceWorker.register(swUrl, { scope: "/" });
  } catch (error) {
    console.error(`registration failed: ${error}`);
  }
};
var register_default = register;

// src/channel.ts
var SWMessageChannel = class {
  constructor() {
    __publicField(this, "channel");
    this.channel = new BroadcastChannel("sw-entitlements");
  }
  sendMessage(type) {
    this.channel.postMessage({ type });
  }
  listenForMessage(callback) {
    const listener = (event) => {
      callback(event);
    };
    this.channel.addEventListener("message", listener);
    return () => {
      this.channel.removeEventListener("message", listener);
    };
  }
};
export {
  SWMessageChannel,
  register_default as register
};
//# sourceMappingURL=index.mjs.map